import React, { useState, useEffect } from 'react';
import { Skeleton, Icon, Divider, Button } from 'antd';
import axios from 'axios';

function UrlPreviewViewer(props) {
  const [thumbnailUrl, setThumbnailUrl] = useState('');
  const [title, setTitle] = useState();
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [failedLoad, setFailedLoad] = useState(false);

  useEffect(() => {
    async function getOpenGraphData() {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append('url', props.url);

        const response = await axios.post(process.env.REACT_APP_REQUEST_VAILD_URL, formData);

        const ogData = response.data;

        setThumbnailUrl(ogData.ogImage.url);
        setTitle(ogData.ogTitle);
        setUrl(ogData.requestUrl);

        setLoading(false);
        setFailedLoad(false);
        props.onCheckValidUrl(true);
      } catch (err) {
        if (err.response.status === 404) {
          const errorMessage =
            props.locale === 'ko' ? '해당 정보를 찾을 수 없습니다. URL을 확인해주세요.' : 'No such information was found.\n Please check the URL.';
          setTitle(errorMessage);
        } else {
          const errorMessage = props.locale === 'ko' ? '문제가 발생했습니다. 다시 시도해주세요.🙏' : 'An error has occurred. Please try again.🙏';
          setTitle(errorMessage);
        }
        setFailedLoad(true);
        setLoading(false);
        props.onCheckValidUrl(false);
      }
    }

    getOpenGraphData();
  }, [props.url]);

  return (
    <Skeleton loading={loading} active avatar className="skeleton-url-preview-viewer">
      {failedLoad ? (
        <div style={{ minWidth: 350, display: 'flex' }}>
          <Icon type="exclamation-circle" theme="filled" style={{ color: '#FFBF00', fontSize: 16, marginTop: 3, marginRight: 16 }} />
          <p className="text-style-body-2" style={{ fontSize: 12 }}>
            {title.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </p>
        </div>
      ) : (
        <div>
          <div style={{ display: 'flex', background: '#F9F9F9', marginBottom: 8 }}>
            <img src={thumbnailUrl} alt="thumbnail" width="56px" height="56" />
            <div style={{ margin: 8, width: 270 }}>
              <p className="text-style-body-2" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {title}
              </p>
              <a href={url} target="_blank" className="text-style-body-4" style={{ color: '#a202ff' }}>
                {url}
              </a>
            </div>
          </div>
          <Divider style={{ margin: 0 }} />
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 11 }}>
            <Button
              className="btn-small"
              onClick={() => {
                props.onCancel();
                props.onVisibleChange();
              }}>
              {props.cancelText}
            </Button>
            <Button
              className="btn-small"
              type="primary"
              onClick={() => {
                props.onVisibleChange();
                props.onCheckValidUrl(true);
              }}
              style={{ marginLeft: 8 }}>
              {props.okText}
            </Button>
          </div>
        </div>
      )}
    </Skeleton>
  );
}

export default UrlPreviewViewer;
